import { IonContent, IonPage } from '@ionic/react';
import Slides from '../components/home/Slides';
import Form from '../components/home/Form';
import Blog from '../components/home/Blog';
import BlocksIcons from '../components/home/BlocksIcons';

const Home = () => {
    return (
        <IonPage className="page-padding-top">
            <IonContent fullscreen>
                <div className="ion-padding">
                    <Slides />
                    <Form />
                    <Blog />
                    <BlocksIcons />
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Home;
